import { FC } from 'react';

import { ImagesApp } from '../../../../constants/images';
import { useI18nContext } from '../../../../hooks/contexts/i18n.context';
import { AppLocale, LOCALES } from '../../../../i18n/locale';
import { LOCALE_BADGES } from '../../../../i18n/localeLabels';
import * as Style from './styles.localeSelect';

const OptionsSelect: FC = () => {
  const { updateLocale } = useI18nContext();

  return (
    <Style.StyledContainerLocaleSelect id="container-locale-select">
      {
        LOCALES.map((locale: AppLocale, index: number) => (
          <Style.StyledButtonLocaleSelect
            id={`button-locale-select_${index}`}
            key={locale}
            onClick={() => updateLocale(locale)}>
            <Style.StyledBadgeLocale
              id={`badge-locale_${index}`}
              src={ImagesApp.countries[locale]} />
            <Style.StyledTextMenu
              id={`text-menu-locale_${index}`}
              data-testid={`text-menu-locale_${index}`}
            >
              {LOCALE_BADGES[locale]}
            </Style.StyledTextMenu>
          </Style.StyledButtonLocaleSelect>
        ))
      }
    </Style.StyledContainerLocaleSelect>
  );
};

export default OptionsSelect;
